<template>
  <div>
    <b-container fluid>
      <b-row class="p-2">
        <b-col cols="auto" class="mr-auto"><h4 class="mb-0 mt-1">{{propsHeaderTitle}}</h4>
              <p>{{propsHeaderInfo}}</p>
        </b-col>
        <b-col cols="auto">
          <div class="d-inline-flex">
<!--            <b-button class="mr-2" size="sm" v-b-toggle.filter-pane-collapse>Filtro</b-button>-->
            <ServerDataToExcel :parameters="propsExcelParameters"/>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  // *****************************************************************************************************************
  //                                                  IMPORTS
  // *****************************************************************************************************************
  import ServerDataToExcel from '../ExcelDownload/ServerDataToExcel'
  export default {
    name: '',
    // *****************************************************************************************************************
    //                                                 MIXINS
    // *****************************************************************************************************************
    mixins: [],
    // *****************************************************************************************************************
    //                                                  PROPS
    // *****************************************************************************************************************
    props: {
      headerTitle: {
        default: 'Sin Título'
      },
      headerInfo: {
        default: 'Sin Info'
      },
      excelParameters: {
        default: () => {}
      }},
    // *****************************************************************************************************************
    //                                                  COMPONENTS
    // *****************************************************************************************************************
    components: {
      ServerDataToExcel
    },
    data () {
      return {
      }
    },
    // *****************************************************************************************************************
    //                                                HOOKS
    // *****************************************************************************************************************
    created () {
    },
    watch: {},
    computed: {
      propsExcelParameters () {
        return this.excelParameters
      },
      propsHeaderTitle () {
        return this.headerTitle
      },
      propsHeaderInfo () {
        return this.headerInfo
      }
    },
    // *****************************************************************************************************************
    //                                                METHODS
    // *****************************************************************************************************************
    methods: {
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/components/GeneralKeyKpiAnalysis/Header.vue